import { useCallback } from 'react';

import type { MeQuery } from '@/api/generated/graphql';
import { ME_QUERY } from '@/api/queries/me';
import { useAuthedClient } from '@/api/useAuthedClient';

import { useGraphQLQuery } from './useGraphQLQuery';

// The authenticated caller, exactly as selected by ME_QUERY.
export type Me = MeQuery['me'];

interface UseMeReturn {
  me: Me | null;
  isLoading: boolean;
  error: Error | null;
  refetch: () => Promise<void>;
}

export function useMe(): UseMeReturn {
  const authedClient = useAuthedClient();

  const { data, isLoading, error, refetch } = useGraphQLQuery<MeQuery>({
    fetcher: (signal) =>
      authedClient.request<MeQuery>({
        document: ME_QUERY,
        signal,
      }),
    deps: [],
  });

  const wrappedRefetch = useCallback(async () => {
    await refetch();
  }, [refetch]);

  return {
    me: data?.me ?? null,
    isLoading,
    error,
    refetch: wrappedRefetch,
  };
}
